import { ThemeMode } from './themeReducer';
import { THEME_ACTION_TYPES } from './themeReducer';

export function setThemeMode(mode: ThemeMode) {
    return { type: THEME_ACTION_TYPES.SET_THEME_MODE, payload: mode };
}

export function toggleTheme() {
    return { type: THEME_ACTION_TYPES.TOGGLE_THEME };
}

